import React from 'react';

const IconMedium = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-medium">
    <title>Medium</title>
    <path d="M4 18V6l4 6 4-6v12" />
    <path d="M18 6v12" />
  </svg>
);

export default IconMedium;
